import { Button, Popover, PopoverContent, PopoverTrigger, useBoolean } from '@chakra-ui/react';
import { useAppSelector } from 'modules/Editor/store';
import { selectHasActiveWidget } from 'modules/Editor/store/widgetSelector';
import { ReactElement, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { LayerMenuOptions } from './LayerMenuOptions';

export const LayerMenu = (): ReactElement => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false });
  const [isOpen, setIsOpen] = useBoolean(false);
  const hasActiveWidget = useAppSelector(selectHasActiveWidget);
  const isDisabled = !hasActiveWidget;

  const label = t('arrange');

  useEffect(() => {
    if (isOpen && isDisabled) setIsOpen.off();
  }, [isOpen, isDisabled, setIsOpen]);

  return (
    <Popover isOpen={isOpen} isLazy onClose={setIsOpen.off} placement='bottom-end'>
      <PopoverTrigger>
        <Button
          variant='ghost-with-active'
          data-testid='widget-layer-menu-trigger-button'
          fontWeight='semibold'
          isDisabled={isDisabled}
          onClick={setIsOpen.toggle}
          isActive={isOpen}
          size='sm'
        >
          {label}
        </Button>
      </PopoverTrigger>
      <PopoverContent w='fit-content' boxShadow='md' padding={0} mt='1px' data-testid='widget-layer-menu-content'>
        <LayerMenuOptions />
      </PopoverContent>
    </Popover>
  );
};
